export default "__VITE_ASSET__Bg97rod8__"